import React from 'react';
import { User, Clock, Calendar, Play, CheckCircle } from 'lucide-react';
import { getSessionConfig, getStatusLabel, getStatusColor } from './SessionHelpers';

export function SessionInfoPanel({ session, isProfessional, onStart, onComplete }) {
  const config = getSessionConfig(session.session_type);

  return (
    <div className="card-theraflow p-6" data-testid="session-info">
      <div className="flex items-center gap-3 mb-4">
        {config && (
          <div className={`w-12 h-12 rounded-xl ${config.color} flex items-center justify-center`}>
            <config.icon className="w-6 h-6 text-white" strokeWidth={1.5} />
          </div>
        )}
        <div>
          <h2 className="text-lg font-medium text-[#292927]" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            Sessão de {config?.label}
          </h2>
          <span className={`text-xs px-2 py-1 rounded-full ${getStatusColor(session.status)}`} data-testid="session-status">
            {getStatusLabel(session.status)}
          </span>
        </div>
      </div>

      <div className="space-y-3 text-sm">
        <div className="flex items-center gap-2 text-[#63635E]">
          <User className="w-4 h-4" />
          {isProfessional ? session.user_name : session.professional_name}
        </div>
        <div className="flex items-center gap-2 text-[#63635E]">
          <Clock className="w-4 h-4" />
          {session.duration_minutes} minutos
        </div>
        {session.scheduled_at && (
          <div className="flex items-center gap-2 text-[#63635E]">
            <Calendar className="w-4 h-4" />
            {new Date(session.scheduled_at).toLocaleString('pt-BR')}
          </div>
        )}
      </div>

      <div className="mt-6 pt-4 border-t border-[#EAE8E3]">
        <div className="flex justify-between text-sm mb-2">
          <span className="text-[#63635E]">Valor da sessão</span>
          <span className="font-medium text-[#292927]">R$ {session.price?.toFixed(2)}</span>
        </div>
        {isProfessional && (
          <>
            <div className="flex justify-between text-sm mb-2">
              <span className="text-[#63635E]">Comissão da plataforma</span>
              <span className="text-[#B85C5C]">- R$ {session.platform_fee?.toFixed(2)}</span>
            </div>
            <div className="flex justify-between text-sm font-medium">
              <span className="text-[#292927]">Seu ganho</span>
              <span className="text-[#6B8E7C]">R$ {session.professional_earnings?.toFixed(2)}</span>
            </div>
          </>
        )}
      </div>

      {isProfessional && session.status === 'scheduled' && (
        <button onClick={onStart} className="btn-primary w-full mt-6 flex items-center justify-center gap-2" data-testid="start-session-btn">
          <Play className="w-4 h-4" /> Iniciar Sessão
        </button>
      )}

      {isProfessional && session.status === 'in_progress' && (
        <button onClick={onComplete} className="btn-primary w-full mt-6 flex items-center justify-center gap-2" data-testid="complete-session-btn">
          <CheckCircle className="w-4 h-4" /> Finalizar Sessão
        </button>
      )}
    </div>
  );
}
